export default __webpack_public_path__ + "static/media/hero-topfeature-banner.2b41b3ce.svg";